import React from 'react';
import { AccordionTrigger } from '@/Components/shadcn';
import { cn } from '@/lib/utils';

export default function RequestInformationAccordionTrigger({ children }: React.PropsWithChildren) {
    return (
        <AccordionTrigger className={cn('text-foreground bg-alicia rounded-none text-base', 'min-h-14 px-6 py-4')}>
            {children}
        </AccordionTrigger>
    );
}
